import {
	FETCH_LOCATION_FLEET_BEGIN,
	FETCH_LOCATION_FLEET_SUCCESS,
	FETCH_LOCATION_FLEET_ERROR,
	FETCH_LOCATION_CALENDAR_BEGIN,
	FETCH_LOCATION_CALENDAR_SUCCESS,
	FETCH_LOCATION_CALENDAR_ERROR,
	CHECK_LOCATIONS_LATE_BEGIN,
	CHECK_LOCATIONS_LATE_SUCCESS,
	CHECK_LOCATIONS_LATE_ERROR,
} from "../actions/locationGererActions"

const initialState = {
	fleet: [],
	fetchFleet: { loading: false, error: false },
	events: [],
	fetchEvents: { loading: false, error: false },
	lateLocs: [],
	fetchLateLocs: { loading: false, error: false },
}

const locationGererReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_LOCATION_FLEET_BEGIN:
			return { ...state, fetchFleet: { loading: true, error: false } }
		case FETCH_LOCATION_FLEET_SUCCESS:
			return {
				...state,
				fleet: action.payload.fleet,
				fetchFleet: { loading: false, error: false },
			}
		case FETCH_LOCATION_FLEET_ERROR:
			return {
				...state,
				fetchFleet: { loading: false, error: action.payload.error },
			}
		case FETCH_LOCATION_CALENDAR_BEGIN:
			return { ...state, fetchEvents: { loading: true, error: false } }
		case FETCH_LOCATION_CALENDAR_SUCCESS:
			return {
				...state,
				events: action.payload.events,
				fetchEvents: { loading: false, error: false },
			}
		case FETCH_LOCATION_CALENDAR_ERROR:
			return {
				...state,
				fetchEvents: { loading: false, error: action.payload.error },
			}
		case CHECK_LOCATIONS_LATE_BEGIN:
			return { ...state, fetchLateLocs: { loading: true, error: false } }
		case CHECK_LOCATIONS_LATE_SUCCESS:
			return {
				...state,
				lateLocs: action.payload.lateLocs,
				fetchLateLocs: { loading: false, error: false },
			}
		case CHECK_LOCATIONS_LATE_ERROR:
			return {
				...state,
				fetchLateLocs: { loading: false, error: action.payload.error },
			}
		default:
			return state
	}
}

export default locationGererReducer
